<script>
export default {
  components: { },
  props: [("component", "handler")],
  data: function () {
    return {
      enabled: Boolean,
      options: [
        { title: "item1", key: 1 },
        { title: "item2", key: 2 },
        { title: "item3", key: 3 },
        { title: "item4", key: 4 },
        { title: "item5", key: 5 },
        { title: "item6", key: 6 },
        { title: "item7", key: 7 },
        { title: "item8", key: 8 },
      ],
      input: "Coucou",
      upload_files: [],
      upload_pending: false,
      mime_types: [],
      filename: null,
      selected: true,
    };
  },
  computed: {},
  methods: {
    toggle: function () {
      this.enabled = !this.enabled;
    },
    update: function (v) {
      console.log(v);
    },
    upload_upload: function (files) {
      console.log("upload_upload");
      // Upload and...
      this.upload_pending = true;
      setTimeout(
        function () {
          this.upload_pending = false;
          this.upload_files = Array.from(files);
          this.filename = files[0].name;
        }.bind(this),
        2000
      );
    },
    upload_delete: function () {
      this.upload_files = [];
    },
  },
};
</script>
    
<template>
  <div class="vfigma-page">
    <!-- BUTTONS -->
    <f-form>
      <template v-slot:title
        ><f-icon icon="fa6-angle-right"></f-icon>{{ $vt('Buttons') }}</template
      >
      <template v-slot:content>
        <div class="items f-form-field">
          <f-button type="primary highlight">Button Primary Highlight</f-button>
          <f-button type="primary highlight"
            ><f-icon icon="fa6-arrow-right"></f-icon>Button Primary Highlight</f-button
          >
          <f-button type="primary highlight"
            >Button Primary<f-icon icon="fa6-arrow-right"></f-icon
          ></f-button>
          <f-button :type="['primary', 'negative', 'highlight']">Button Primary Negative !</f-button>
        </div>
        <div class="items f-form-field">
          <f-button type="primary">Button Primary</f-button>
          <f-button type="primary"
            ><f-icon icon="fa6-arrow-right"></f-icon>Button Primary</f-button
          >
          <f-button type="primary"
            >Button Primary<f-icon icon="fa6-arrow-right"></f-icon
          ></f-button>
          <f-button :type="['primary', 'negative']">Button Primary Negative !</f-button>
        </div>
        <div class="items f-form-field">
          <f-button type="secondary">Button Secondary</f-button>
          <f-button type="secondary"
            ><f-icon icon="fa6-arrow-right"></f-icon>Button Secondary</f-button
          >
          <f-button type="secondary"
            >Button Secondary<f-icon icon="fa6-arrow-right"></f-icon
          ></f-button>
          <f-button :type="['secondary', 'negative']">Button Secondary Negative !</f-button>
        </div>
        <div class="items f-form-field">
          <f-button type="tertiary">Button Tertiary</f-button>
          <f-button type="tertiary"
            ><f-icon icon="fa6-arrow-right"></f-icon>Button Tertiary</f-button
          >
          <f-button type="tertiary"
            >Button Tertiary<f-icon icon="fa6-arrow-right"></f-icon
          ></f-button>
          <f-button :type="['tertiary', 'negative']">Button Tertiary Negative !</f-button>
        </div>
      </template>
    </f-form>
    <f-form class="overlay">
      <template v-slot:title
        ><f-icon icon="fa6-angle-right"></f-icon>{{ $vt('Buttons Overlay') }}</template
      >
      <template v-slot:content>
        <div class="items f-form-field">
          <f-button :type="['primary', 'overlay']"
            >Button Primary Overlay</f-button
          >
          <f-button :type="['primary', 'overlay']"
            ><f-icon icon="fa6-arrow-right"></f-icon>Button Primary
            Overlay</f-button
          >
          <f-button :type="['primary', 'overlay']"
            >Button Primary Overlay<f-icon icon="fa6-arrow-right"></f-icon
          ></f-button>
        </div>
        <div class="items f-form-field">
          <f-button :type="['secondary', 'overlay']"
            >Button Seconday Overlay</f-button
          >
          <f-button :type="['secondary', 'overlay']"
            ><f-icon icon="fa6-arrow-right"></f-icon>Button Seconday
            Overlay</f-button
          >
          <f-button :type="['secondary', 'overlay']"
            >Button Seconday Overlay<f-icon icon="fa6-arrow-right"></f-icon
          ></f-button>
        </div>
        <div class="items f-form-field">
          <f-button :type="['tertiary', 'overlay']"
            >Button Tertiary Overlay</f-button
          >
          <f-button :type="['tertiary', 'overlay']"
            ><f-icon icon="fa6-arrow-right"></f-icon>Button Tertiary
            Overlay</f-button
          >
          <f-button :type="['tertiary', 'overlay']"
            >Button Tertiary Overlay<f-icon icon="fa6-arrow-right"></f-icon
          ></f-button>
        </div>
      </template>
    </f-form>
    <!-- LINKS -->
    <f-form>
      <template v-slot:title
        ><f-icon icon="fa6-angle-right"></f-icon>{{ $vt('Links') }}</template
      >
      <template v-slot:content>
        <div class="items f-form-field">
          <f-button href="test" type="primary">Button Primary</f-button>
          <f-button href="test" type="primary"
            ><f-icon icon="fa6-arrow-right"></f-icon>Button Primary</f-button
          >
          <f-button href="test" type="primary"
            >Button Primary<f-icon icon="fa6-arrow-right"></f-icon
          ></f-button>
          <f-button href="test" :type="['primary', 'negative']">Button Primary Negative !</f-button>
        </div>
        <div class="items f-form-field">
          <f-button href="test" type="secondary">Button Secondary</f-button>
          <f-button href="test" type="secondary"
            ><f-icon icon="fa6-arrow-right"></f-icon>Button Secondary</f-button
          >
          <f-button href="test" type="secondary"
            >Button Secondary<f-icon icon="fa6-arrow-right"></f-icon
          ></f-button>
          <f-button href="test" :type="['secondary', 'negative']">Button Secondary Negative !</f-button>
        </div>
        <div class="items f-form-field">
          <f-button href="test" type="tertiary">Button Tertiary</f-button>
          <f-button href="test" type="tertiary"
            ><f-icon icon="fa6-arrow-right"></f-icon>Button Tertiary</f-button
          >
          <f-button href="test" type="tertiary"
            >Button Tertiary<f-icon icon="fa6-arrow-right"></f-icon
          ></f-button>
          <f-button href="test" :type="['tertiary', 'negative']">Button Tertiary Negative !</f-button>
        </div>
      </template>
    </f-form>
    <f-form class="overlay">
      <template v-slot:title
        ><f-icon icon="fa6-angle-right"></f-icon>{{ $vt('Links Overlay') }}</template
      >
      <template v-slot:content>
        <div class="items f-form-field">
          <f-button href="test" :type="['primary', 'overlay']"
            >Button Primary Overlay</f-button
          >
          <f-button href="test" :type="['primary', 'overlay']"
            ><f-icon icon="fa6-arrow-right"></f-icon>Button Primary
            Overlay</f-button
          >
          <f-button href="test" :type="['primary', 'overlay']"
            >Button Primary Overlay<f-icon icon="fa6-arrow-right"></f-icon
          ></f-button>
        </div>
        <div class="items f-form-field">
          <f-button href="test" :type="['secondary', 'overlay']"
            >Button Seconday Overlay</f-button
          >
          <f-button href="test" :type="['secondary', 'overlay']"
            ><f-icon icon="fa6-arrow-right"></f-icon>Button Seconday
            Overlay</f-button
          >
          <f-button href="test" :type="['secondary', 'overlay']"
            >Button Seconday Overlay<f-icon icon="fa6-arrow-right"></f-icon
          ></f-button>
        </div>
        <div class="items f-form-field">
          <f-button href="test" :type="['tertiary', 'overlay']"
            >Button Tertiary Overlay</f-button
          >
          <f-button href="test" :type="['tertiary', 'overlay']"
            ><f-icon icon="fa6-arrow-right"></f-icon>Button Tertiary
            Overlay</f-button
          >
          <f-button href="test" :type="['tertiary', 'overlay']"
            >Button Tertiary Overlay<f-icon icon="fa6-arrow-right"></f-icon
          ></f-button>
        </div>
      </template>
    </f-form>
    <f-form>
      <template v-slot:title
        ><f-icon icon="fa6-angle-right"></f-icon>{{ $vt('Buttons Specials') }}</template
      >
      <template v-slot:content>
        <div class="items f-form-field">
          <f-button type="highlight">Button Highlight</f-button>
          <f-button type="highlight"
            ><f-icon icon="fa6-arrow-right"></f-icon>Button Highlight</f-button
          >
          <f-button type="highlight"
            >Button Highlight<f-icon icon="fa6-arrow-right"></f-icon
          ></f-button>
        </div>
        <div class="items f-form-field">
          <f-button type="filled">Button filled</f-button>
          <f-button type="filled"
            ><f-icon icon="fa6-arrow-right"></f-icon>Button filled</f-button
          >
          <f-button type="filled"
            >Button filled<f-icon icon="fa6-arrow-right"></f-icon
          ></f-button>
        </div>
        <div class="items f-form-field">
          <f-button type="transparent">Button transparent</f-button>
          <f-button type="transparent"
            ><f-icon icon="fa6-arrow-right"></f-icon>Button transparent</f-button
          >
          <f-button type="transparent"
            >Button transparent<f-icon icon="fa6-arrow-right"></f-icon
          ></f-button>
        </div>
        <div class="items f-form-field">
          <f-button type="link">Button Link</f-button>
        </div>
      </template>
    </f-form>
    <f-form>
      <template v-slot:title
        ><f-icon icon="fa6-angle-right"></f-icon>{{ $vt('Links') }}</template
      >
      <template v-slot:content>
        <div class="items f-form-field">
          <f-link href="" type="small" blank>Small Link</f-link>
          <f-link href="" type="small" blank><f-icon icon="fa6-arrow-right"></f-icon>Small Link</f-link>
          <f-link href="" type="small" blank>Small Link<f-icon icon="fa6-arrow-right"></f-icon></f-link>
        </div>
        <div class="items f-form-field">
          <f-link href="">MediumLink</f-link>
          <f-link href=""><f-icon icon="fa6-arrow-right"></f-icon>MediumLink</f-link>
          <f-link href="">MediumLink<f-icon icon="fa6-arrow-right"></f-icon></f-link>
        </div>
        <div class="items f-form-field">
          <f-link href="" type="large">Large Link</f-link>
          <f-link href="" type="large"><f-icon icon="fa6-arrow-right"></f-icon>Large Link</f-link>
          <f-link href="" type="large">Large Link<f-icon icon="fa6-arrow-right"></f-icon></f-link>
        </div>
      </template>
    </f-form>
    <f-form>
      <template v-slot:title
        ><f-icon icon="fa6-angle-right"></f-icon>{{ $vt('Input') }}</template
      >
      <template v-slot:content>
        <div class="items f-form-field">
          <f-textfield placeholder="Textfield" :input.sync="input">
            <template v-slot:label>
              Textfield input
            </template>
            <template v-slot:helper>
              Textfield input helper
            </template>
          </f-textfield>
          <f-textfield placeholder="Textfield" :input.sync="input" :error="true">
            <template v-slot:label>
              Textfield input in error state
            </template>
            <template v-slot:helper>
              Textfield input helper
            </template>
          </f-textfield>
          <f-textfield placeholder="Textfield" :input.sync="input" :disabled="true">
            <template v-slot:label>
              Textfield input disabled
            </template>
            <template v-slot:helper>
              Textfield input helper
            </template>
          </f-textfield>
        </div>
        <div class="items f-form-field">
          <f-textfield placeholder="Textfield" :input.sync="input">
            <template v-slot:label>
              Textfield input with action
            </template>
            <template v-slot:action>
              <f-button type="primary">
                <f-icon icon="fa6-paper-plane"></f-icon>
              </f-button>
            </template>
            <template v-slot:helper>
              Textfield input helper
            </template>
          </f-textfield>
        </div>
        <div class="items f-form-field">
          <f-password placeholder="Password" :input.sync="input" optional>
            <template v-slot:label>
              Password input
            </template>
            <template v-slot:helper>
              Password input helper
            </template>
          </f-password>
        </div>
        <div class="items f-form-field">
          <f-textarea select-on-focus placeholder="Password" :input.sync="input" optional>
            <template v-slot:label>
              Textarea input
            </template>
            <template v-slot:helper>
              Textarea input helper
            </template>
          </f-textarea>
        </div>
      </template>
    </f-form>
    <f-form>
      <template v-slot:title
        ><f-icon icon="fa6-angle-right"></f-icon>{{ $vt('Value') }}</template
      >
      <template v-slot:content>
        <div class="items f-form-field">
          <f-value>
            <template v-slot:value>
              Here is the value
            </template>
            <template v-slot:label>
              <f-icon icon="fa6-heart"></f-icon>Value label
            </template>
            <template v-slot:helper>
              Here is the helper
            </template>
          </f-value>
        </div>
        
      </template>
    </f-form>
    <f-form>
      <template v-slot:title
        ><f-icon icon="fa6-angle-right"></f-icon>{{ $vt('Toggle') }}</template
      >
      <template v-slot:content>
        <div class="f-form-field">
          <f-toggle :enabled="enabled" @toggle="toggle()"
            ><f-icon icon="fa6-toggle-on"></f-icon>Toggle component</f-toggle
          >
        </div>
        <div class="f-form-field">
          <f-toggle :enabled="enabled" @toggle="toggle()" type="big"
            ><f-icon icon="fa6-toggle-on"></f-icon>Toggle component</f-toggle
          >
        </div>
      </template>
    </f-form>

    <f-form>
      <template v-slot:title><f-icon icon="fa6-angle-right"></f-icon>{{ $vt('Dialogs') }}</template>
      <template v-slot:content>

        <f-dialog title2="Dialog" style="width:400px">
          <template #content>
            Content
          </template>
          <template #actions>
            <f-button type="tertiary" >Cancel</f-button>
            <f-button type="primary" >OK</f-button>
          </template>
        </f-dialog>

         <f-dialog title2="Pending Dialog" pending="true" style="width:400px">
          <template #content>
            Content
          </template>
          <template #actions>
            <f-button type="tertiary" >Cancel</f-button>
            <f-button type="primary" pending>Ok</f-button>
          </template>
        </f-dialog>
      </template>
    </f-form>

    <f-form>
      <template v-slot:title><f-icon icon="fa6-angle-right"></f-icon>{{ $vt('Select') }}</template>
      <template v-slot:content>
        <f-select :options="options" unselect-label="No value">
          <template v-slot:label>Select</template>
			    <template v-slot:helper>Un peu d'aide si besoin</template>
        </f-select>
      </template>
    </f-form>

    <f-form>
      <template v-slot:title><f-icon icon="fa6-angle-right"></f-icon>{{ $vt('Upload') }}</template>
      <template v-slot:content>
        <div class="f-form-field">
          <f-multi-upload files-count-label="files uploaded" @change="upload_upload($event)"
            :pending="upload_pending" @delete="upload_delete()" :files="upload_files"
            :accept="mime_types.join(',')">
            <div style="flex: 1 1 auto;">Upload slides</div>
            <f-icon icon="fa6-upload"></f-icon>
          </f-multi-upload>
        </div>
        <div class="f-form-field">
          <f-upload @change="upload_upload($event)" :accept="mime_types.join(',')" :pending="upload_pending" @delete="upload_delete()"
          :filename="filename">
            <div style="flex: 1 1 auto;">Upload slides</div>
            <f-icon icon="fa6-upload"></f-icon>
          </f-upload>
        </div>
      </template>
    </f-form>

    <f-form>
      <template v-slot:title><f-icon icon="fa6-angle-right"></f-icon>{{ $vt('FLoaderCircular') }}</template>
      <template v-slot:content>
        <FLoaderCircularDemo />
      </template>
    </f-form>

    <f-form>
      <template v-slot:title>FTabs</template>
      <template v-slot:content>
        <f-project-tabs-demo></f-project-tabs-demo>
      </template>
    </f-form>

    <f-form>
      <template v-slot:title>FMiniTabs</template>
      <template v-slot:content>
        <f-mini-tabs>
          <f-mini-tab icon="fa-bomb" label="Bomb"></f-mini-tab>
          <f-mini-tab icon="fa-rocket" label="Rocket" selected="true"></f-mini-tab>
          <f-mini-tab icon="fa6-atom" label="Atom"></f-mini-tab>
        </f-mini-tabs>
      </template>
    </f-form>

    <f-form>
      <template v-slot:title>Sexy Scroll</template>
      <template v-slot:content>
        <f-sexy-scroll style="width:300px;height:300px">
          <img src="https://images.theconversation.com/files/443350/original/file-20220131-15-1ndq1m6.jpg?ixlib=rb-1.1.0&rect=0%2C0%2C3354%2C2464&q=45&auto=format&w=926&fit=clip"></img>
        </f-sexy-scroll>
      </template>
    </f-form>

    <f-form>
      <template v-slot:title>Info</template>
      <template v-slot:content>
        <f-info style="margin-bottom:10px">Voilà un message à caractère informatif</f-info>
        <f-info style="margin-bottom:10px" class="warning">Mon info</f-info>
        <f-info style="margin-bottom:10px" class="error">Mon info</f-info>
      </template>
    </f-form>
    <f-form>
      <template v-slot:title>Description</template>
      <template v-slot:content>
        <f-description>Voilà un message à caractère descriptif</f-description>
      </template>
    </f-form>

    <f-form>
      <template v-slot:title>Thumb</template>
      <template v-slot:content>
        <f-thumb style="margin-bottom:10px">Voilà un message à caractère descriptif</f-thumb>
        <f-thumb style="margin-bottom:10px" removable>Voilà un message à caractère descriptif</f-thumb>
        <f-thumb style="margin-bottom:10px" selected>Voilà un message à caractère descriptif</f-thumb>
        <f-thumb selected removable>Voilà un message à caractère descriptif</f-thumb>
      </template>
    </f-form>

    <f-form>
      <template v-slot:title>Toast</template>
      <template v-slot:content>
        <div style="display: flex; flex-direction: column; align-items: center; gap:16px;">
          <f-toast>message</f-toast>
          <f-toast icon="fa6-info">message</f-toast>
          <f-toast icon="fa6-info">
            message 
            <template #action>
            <f-icon icon="fa-close"></f-icon>
          </template>
          </f-toast>
          <f-toast class="error" icon="fa6-warning">
            message 
            <template #action>
            Yolo
          </template>
          </f-toast>
        </div>
      </template>
    </f-form>

    <f-form>
      <template v-slot:title>Drop down & List item</template>
      <template v-slot:content>
        <f-list-item icon="fa6-gears" 
								variant="default left">
          List item
        </f-list-item>
        <div style="width: min-content">
          <f-drop-down-box ref="dropdown">
            <template #button>
              <f-drop-down-button variant="default" @click="$refs.dropdown.toggle()">
                <f-icon icon="fa6-gear"></f-icon>Dropdown
              </f-drop-down-button>
            </template>
            <template #dropdown>
              <f-list-item icon="fa6-gears" 
                  variant="default left">List item 1
              </f-list-item>
              <f-list-item icon="fa6-gears" 
                  variant="default left">List item 2
              </f-list-item>
              <f-list-item icon="fa6-gears" 
                  variant="default left">List item 3
              </f-list-item>
            </template>
          </f-drop-down-box>
        </div>
      </template>
    </f-form>

    <f-form>
      <template v-slot:title>Hint</template>
      <template v-slot:content>
        <f-hint icon="fa6-gears">
          <template #title>Le titre ici</template>
          <template #message>Ici, c'est le message</template>
          <template #action>
            <f-button>X</f-button>
          </template>
        </f-hint>
        <f-hint icon="fa6-gears" type="negative">
          <template #title>Le titre ici</template>
          <template #message>Ici, c'est le message</template>
          <template #action>
            <f-button>X</f-button>
          </template>
        </f-hint>
      </template>
    </f-form>

    <f-form>
      <template v-slot:title>Radio Button Card</template>
      <template v-slot:content>
        <f-radio-button-cards>
          <f-radio-button-card icon="fa6-gears" :selected="selected" @click="selected=!selected">
            <template #title>Le titre ici</template>
            <template #description>Ici, c'est le message</template>
          </f-radio-button-card>
          <f-radio-button-card icon="fa6-gears" :selected="selected" @click="selected=!selected">
            <template #title>Le titre ici</template>
            <template #description>Ici, c'est le message</template>
          </f-radio-button-card>
        </f-radio-button-cards>
      </template>
    </f-form>


  </div>
</template>

<style lang="scss" scoped>
.vfigma-page {
  height: 100%;
  overflow-y: auto;

  /* width */
  &::-webkit-scrollbar {
    width: 16px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-track:hover {
    background: #f3f3f3;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    border: 4px solid transparent;
    background: #dddddd;
    border-radius: 8px;
    background-clip: content-box;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #dddddd;
    background-clip: content-box;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:active {
    background: #bbbbbb;
    background-clip: content-box;
  }
}

.f-form {
  margin: 20px;

  .items {
    display: flex;

    > * {
      margin-right: 10px;
    }
  }

  &.overlay {

    .title {
    }
  }
}
</style>